import type { MediaUnitSortKey } from '@ooh/contracts';
import type { MediaUnitsSearch } from './validate-search';

/**
 * Computes the next search params after a sort click.
 * Pure function - no side effects, no router dependency.
 */
export function computeNextSort(
  prev: MediaUnitsSearch,
  key: string,
  shiftKey: boolean,
): MediaUnitsSearch {
  const next = { ...prev };
  const sortBy = prev.sortBy ?? 'id';
  const sortDir = prev.sortDir ?? 'asc';
  const sortBy2 = prev.sortBy2;
  const sortDir2 = prev.sortDir2 ?? 'asc';

  if (shiftKey) {
    // Shift-click: manage secondary sort
    if (key === sortBy) return next; // no-op: same as primary
    if (key === sortBy2) {
      if (sortDir2 === 'asc') {
        next.sortDir2 = 'desc';
      } else {
        delete next.sortBy2;
        delete next.sortDir2;
      }
    } else {
      next.sortBy2 = key as MediaUnitSortKey;
      next.sortDir2 = 'asc';
    }
  } else {
    // Normal click: set primary sort, clear secondary
    if (key === sortBy) {
      next.sortDir = sortDir === 'asc' ? 'desc' : 'asc';
    } else {
      next.sortBy = key as MediaUnitSortKey;
      next.sortDir = 'asc';
    }
    delete next.sortBy2;
    delete next.sortDir2;
  }
  return next;
}
